import React, { useContext, useState, useRef } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { ToastContext } from "../../contexts/toast/toastContext";

import { Form } from "@unform/web";
import { SubmitHandler, FormHandles } from "@unform/core";
import getValidationErrors from "../../helpers/getValidateErrors";
import { TextArea } from "../../components/Form";
import './styles.css'
import * as Yup from "yup";

import { ToastErrorContext } from "../../contexts/toast/toastErrorContext";
import * as faleconoscoService from "../../services/faleconosco";
import { IFaleconosco } from "../../common/interfaces/faleconosco.interfaces";
import { ContatoCem } from "./components";

const Contato: React.FC = () => {


  // Refs
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);


  //Context
  const toastContext = useContext(ToastContext);
  const toastError = useContext(ToastErrorContext);

  // Handles
  const handleSave = () => {
    formRef.current?.submitForm();
  };

  const handleSubmit: SubmitHandler = async (
    faleconosco: IFaleconosco,
    { reset }
  ) => {
    try {

      setLoading(true);
      formRef.current?.setErrors({});

      const message = "Campo obrigatório";

      const schema = Yup.object().shape({
        mensagem: Yup.string().required(message),
      });

      await schema.validate(faleconosco, { abortEarly: false });

      let request = {
        assunto: "Portal do Cliente - Dúvidas ou sugestões",
        mensagem: faleconosco.mensagem
      }

      await faleconoscoService.enviar(request);
      reset();

      //Toast
      toastContext.notification("A ação foi concluída.", "success");
    } catch (err) {
      formRef.current?.setErrors(getValidationErrors(err));
      toastError.notification(err);
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="content py-3">
        <div className="container-xl mb-3">
          <div className="page-header">
            <div className="row">
              <h1>Contato</h1>
            </div>
          </div>
          <div className={'dimmer' + (loading ? ' active' : '')}>
            <div className="loader"></div>
            <div className={"dimmer-content" + (loading ? ' medium-box-loader' : '')} >
              <Form ref={formRef} onSubmit={handleSubmit}>
                <div>
                  <Row>
                    <Col lg={5} className="card p-4">
                      <div className="card-body">
                        <div className="card-conteudo">
                            <div>
                              <ContatoCem /> 
                            </div>
                        </div>
                      </div>
                    </Col>
                    <Col lg={7} className="card p-4">
                      <div className="card-body">
                        <h1 className="text-center">
                          Tem alguma dúvida ou sugestão?
                        </h1>
                        <p className="card-description"  style={{textAlign:"justify"}}>
                          Por favor, entre em contato conosco preenchendo os campos  abaixo que retornaremos o quanto antes!
                        </p>
                        <div className="row">
                          <div className="col-md-12 mt-3">
                            <label>Mensagem:</label>
                            <TextArea className="form-control textarea" name="mensagem" />
                          </div>
                          <span className="mt-3 col-auto ml-auto">
                            <Button variant="btn btn-primary " onClick={handleSave}>
                              Enviar
                              <i className="fa fa-paper-plane ml-2" aria-hidden="true"></i>
                            </Button>
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Form>
            </div></div>
        </div>
      </div>
    </>
  );
};

export default Contato;
